var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"px-8"},[_c('div',{staticClass:"ma-0 pa-0 mb-4 text--section-title"},[_vm._v("Your Contribution Summary")]),_c('HrmDataTable',{attrs:{"isEditMode":false,"hrmMemberTimeSheets":_vm.hrmTimeSheets,"userId":_vm.user.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }